import { useSearchParams } from "react-router-dom";
import { MapPin, Phone, Mail, ArrowUpRight, Store, ShieldCheck, Truck } from "lucide-react";
import { PageHero } from "../components/site/PageHero";
import { TrackTool } from "../components/site/TrackTool";
import { QuoteTool } from "../components/site/QuoteTool";
import { PuntoEnvioMark } from "../components/site/PuntoEnvioMark";
import { FadeUp } from "../components/site/Motion";
import { PUNTOENVIO } from "../lib/site";

const PERKS = [
  { Icon: Store, t: "Despachá y retirá en agencia", d: "Llevá tu paquete a la agencia más cercana y retiralo en destino." },
  { Icon: ShieldCheck, t: "Tu envío, siempre a la vista", d: "Con el número de orden ves por dónde va, de punta a punta." },
  { Icon: Truck, t: "Cobertura nacional", d: "Viaja en nuestras unidades y en la red PuntoEnvío." },
];

export default function PuntoEnvio() {
  const [sp] = useSearchParams();
  return (
    <>
      <PageHero testid="puntoenvio-hero" dark eyebrow="Encomiendas y cargas" lines={["Tu encomienda", <span key="l" className="text-[var(--lime)]">viaja con nosotros.</span>]} intro="Cotizá el envío, despachá en agencia y seguí cada etapa desde acá.">
        <div className="mt-10"><PuntoEnvioMark size="text-4xl md:text-6xl" /></div>
        <div className="mt-14 grid gap-6">
          <TrackTool initialCode={sp.get("code") || ""} />
          <QuoteTool />
        </div>
      </PageHero>
      <section className="bg-[var(--paper)] py-20 md:py-28">
        <div className="mx-auto grid max-w-[1400px] gap-4 px-5 md:grid-cols-3 md:px-10">
          {PERKS.map(({ Icon, t, d }, i) => (
            <FadeUp key={t} delay={i * 0.08} className="rounded-[28px] bg-white p-8">
              <Icon className="h-8 w-8 text-[var(--forest)]" />
              <p className="mt-6 font-display-up text-xl">{t}</p>
              <p className="mt-2 text-[var(--muted-ink)]">{d}</p>
            </FadeUp>
          ))}
        </div>
        <FadeUp className="mx-auto mt-4 max-w-[1400px] px-5 md:px-10">
          <div data-testid="puntoenvio-contact" className="flex flex-col gap-6 rounded-[28px] bg-[var(--ink)] p-8 text-white md:flex-row md:items-center md:justify-between md:p-10">
            <div className="space-y-2 text-white/85">
              <p className="flex items-center gap-2"><MapPin className="h-4 w-4 text-[var(--lime)]" /> {PUNTOENVIO.address}</p>
              <p className="flex items-center gap-2"><Phone className="h-4 w-4 text-[var(--lime)]" /> Teléfono {PUNTOENVIO.phone}</p>
              <p className="flex items-center gap-2"><Phone className="h-4 w-4 text-[var(--lime)]" /> WhatsApp {PUNTOENVIO.whatsapp}</p>
              <p className="flex items-center gap-2"><Mail className="h-4 w-4 text-[var(--lime)]" /> {PUNTOENVIO.email}</p>
            </div>
            <a href={PUNTOENVIO.url} target="_blank" rel="noopener noreferrer" data-testid="puntoenvio-site-link" className="group inline-flex items-center gap-2 self-start rounded-full bg-[var(--lime)] px-6 py-3 font-bold text-[var(--ink)]">
              Ir a puntoenvio.com <ArrowUpRight className="h-4 w-4 transition-transform group-hover:rotate-45" />
            </a>
          </div>
        </FadeUp>
      </section>
    </>
  );
}
